import { useTranslation } from 'react-i18next';

import { Checkbox } from '@/ui';
import { FormItem } from '@/components';

import { StyledCategoryFlagCheckboxLabel, StyledRestorationCheckboxWrap } from '../Styled';

type CategoryIsHeavyFieldProps = {
  fieldName: string;
};

const CategoryIsHeavyField = ({ fieldName }: CategoryIsHeavyFieldProps) => {
  const { t } = useTranslation(['categories']);

  return (
    <StyledRestorationCheckboxWrap>
      <FormItem name={fieldName} valuePropName="checked">
        <Checkbox>
          <StyledCategoryFlagCheckboxLabel>{t('category_is_heavy_label')}</StyledCategoryFlagCheckboxLabel>
        </Checkbox>
      </FormItem>
    </StyledRestorationCheckboxWrap>
  );
};

export default CategoryIsHeavyField;
